import React, { useEffect, useState } from "react";

export default function TelaAulaExercicio(props) {

	return (
		<div className="telaAulaBoxExercicio" style={{ flexDirection: props.namesBottom ? 'column-reverse' : 'column' }}>
			<div className="telaAulaNomesContainer">
				<div className="telaAulaNomesLetra">{props.letra}</div>

				<div className="telaAulaNomesNome">
					<p>{props.nome1}</p>
				</div>

				<div className="telaAulaNomesNome">
					<p>{props.nome2}</p>
				</div>
			</div>

			<div className={`telaAulaVideo ${props.customVideoClass}`}>
				<video playsInline autoPlay muted loop id="telaAulaVideo">
					<source src={props.videoUrl} type="video/mp4" />
				</video>
			</div>
		</div>
	);
}